import { inject } from '@angular/core';
import type { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { navigateOrReport } from '../util/navigate-or-report.util';

/**
 * Route guard for reset-password routes — requires a non-empty `token` query param.
 *
 * Blocks activation and redirects to `/login` when the token is missing or blank,
 * so the reset form never renders without a valid invitation link.
 *
 * @returns `true` when `?token=` is present and non-empty; otherwise `false` after redirect.
 * @example
 * import { resetPasswordTokenGuard } from '@indutrust/auth-data';
 *
 * {
 *   path: 'reset-password',
 *   canActivate: [resetPasswordTokenGuard],
 *   loadChildren: async () =>
 *     import('@indutrust/auth-feature').then((m) => m.authResetPasswordRoutes),
 * }
 */
export const resetPasswordTokenGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const token = route.queryParamMap.get('token')?.trim() ?? '';

  if (token.length === 0) {
    navigateOrReport(router, ['login'], 'Error navigating to Login');
    return false;
  }

  return true;
};
